import React, { useState, useEffect } from "react";
import { Form, Input, Select, Button, Col, Row, message } from "antd";
import commonService from "../../services/commonService";
import paymentOperationsService from "../../services/paymentOperationsService"; // Import the service

const { Option } = Select;

function CreditToWallet({ closeModal }) {
  const [form] = Form.useForm();
  const [currencyList, setCurrencyList] = useState([]);
  const [loading, setLoading] = useState(false);
  // Handle Form Submit
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      // Prepare payload for the creditToWallet function
      const payload = {
        user: values.user,
        currency: values.currency,
        amount: values.creditAmount,
      };

      // Call creditToWallet service
      const response = await paymentOperationsService.creditToWallet(payload);

      if (response.success) {
        message.success("Credit to wallet successful!");
        
        setLoading(false);
        closeModal();
        form.resetFields();
      } else {
        setLoading(false);

        message.error("Failed to credit to wallet.");
      }
    } catch (error) {
      setLoading(false);

      message.error("An error occurred while processing the request.");
    }
  };

  useEffect(() => {
    const fetchCurrencyList = async () => {
      try {
        const response = await commonService.getCurrencyList();
        if (response.success) {
          setCurrencyList(response?.data?.data?.currency);
        } else {
          message.error("Failed to fetch currency list.");
        }
      } catch (error) {
        message.error("An error occurred while fetching currencies.");
      }
    };

    fetchCurrencyList();
  }, []);

  return (
    <>
      <Form
        style={{ width: "100%" }}
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
    >
        <Row gutter={[2, 4]} style={{ width: "100%" }}>
          <Col sm={24} md={12} lg={12}>
            <Form.Item
              name="user"
              label="User"
              rules={[
                { required: true, message: "Please enter username or email!" },
              ]}
              
              >
              <Input placeholder="Enter username or email" />
            </Form.Item>
          </Col>
          <Col sm={24} md={12} lg={12}>
            <Form.Item
              name="currency"
              label="Currency"
              rules={[
                { required: true, message: "Please select a currency!" },
              ]}>
              <Select placeholder="Select currency">
                {currencyList.map((currency) => (
                  <Option key={currency} value={currency}>
                    {currency}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Col span={24}>
          <Form.Item
            name="creditAmount"
            label="Credit Amount"
            style={{ width: "100%" }}
            rules={[
              { required: true, message: "Please enter the credit amount!" },
            ]}>
            <Input type="number" placeholder="Enter credit amount" />
          </Form.Item>
        </Col>

        <Row
          justify="end"
          align="bottom"
          style={{ width: "100%", marginTop: "10px" }}>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
              Submit
            </Button>
            <Button onClick={() => form.resetFields()}>Reset</Button>
          </Form.Item>
        </Row>
      </Form>
    </>
  );
}

export default CreditToWallet;
